// extracted by mini-css-extract-plugin
module.exports = {"banner":"dece2e673c--banner--wBfOY"};